import { ApiService } from '@shared/services';
import { ProfileModel } from '@shared/models/Profile';
import { USER_ROLE } from '@shared/models/constants';

export class ProfileService extends ApiService {
  constructor() {
    super('/profile');
  }

  getProfile(): Promise<ProfileModel> {
    return this.get(`/${localStorage.getItem(USER_ROLE)}/get`);
  }
}
